import React, { useCallback, useEffect, useState } from "react";

const QuoteSendPanel = ({
  open,
  defaultRecipient,
  defaultSubject,
  defaultBody,
  onClose,
  onSend,
  busy,
}) => {
  const [recipientEmail, setRecipientEmail] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [emailBody, setEmailBody] = useState("");

  useEffect(() => {
    if (!open) return;

    setRecipientEmail(defaultRecipient || "");
    setEmailSubject(defaultSubject || "");
    setEmailBody(defaultBody || "");
  }, [open, defaultRecipient, defaultSubject, defaultBody]);

  const handleSend = useCallback(() => {
    if (!recipientEmail.trim()) return;

    onSend({
      recipientEmail: recipientEmail.trim(),
      emailSubject: emailSubject.trim(),
      emailBody: emailBody.trim(),
    });
  }, [recipientEmail, emailSubject, emailBody, onSend]);

  if (!open) return null;

  return (
    <div className="crm-modal-overlay">
      <div className="crm-modal-card">
        <div className="crm-modal-header">
          <h3
            className="crm-page-title"
            style={{ fontSize: "20px", marginBottom: 0 }}
          >
            Send Quote
          </h3>
        </div>

        <div className="crm-form-group">
          <label>Recipient Email</label>
          <input
            className="crm-input"
            value={recipientEmail}
            onChange={(event) => setRecipientEmail(event.target.value)}
            placeholder="customer@email.com"
          />
        </div>

        <div className="crm-form-group">
          <label>Subject</label>
          <input
            className="crm-input"
            value={emailSubject}
            onChange={(event) => setEmailSubject(event.target.value)}
            placeholder="Your KostPadi Quote"
          />
        </div>

        <div className="crm-form-group">
          <label>Email Body</label>
          <textarea
            className="crm-textarea"
            rows={8}
            value={emailBody}
            onChange={(event) => setEmailBody(event.target.value)}
            placeholder="Write your message"
          />
        </div>

        <div className="crm-inline-actions">
          <button
            className="crm-primary-btn"
            onClick={handleSend}
            disabled={busy}
          >
            {busy ? "Sending..." : "Mark as Sent"}
          </button>

          <button
            className="crm-secondary-btn"
            onClick={onClose}
            disabled={busy}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuoteSendPanel;
